import { BadgeStyled } from './Badge.style'

interface BadgeProps {
  type: 'common' | 'rare' | 'epic' | 'heroic' | 'legendary'
}

export const Badge = ({ type }: BadgeProps) => {
  return <BadgeStyled type={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</BadgeStyled>
}
